import { render, staticRenderFns } from "./StockNotes.vue?vue&type=template&id=ffd681fc&scoped=true&"
import script from "./StockNotes.vue?vue&type=script&lang=js&"
export * from "./StockNotes.vue?vue&type=script&lang=js&"
import style0 from "./StockNotes.vue?vue&type=style&index=0&id=ffd681fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd681fc",
  null
  
)

export default component.exports